import { ScreenerDimension } from '@revelio/data-access';

import { FilterId } from '../../../filters/types/filters';

export const mapFilterIdToScreenerDimension = (
  filterId?: FilterId
): ScreenerDimension | undefined => {
  switch (filterId) {
    case FilterId.COMPANY:
      return ScreenerDimension.Company;
    case FilterId.GEOGRAPHY:
      return ScreenerDimension.Geography;
    case FilterId.ROLE:
      return ScreenerDimension.Role;
    default:
      return undefined;
  }
};
